import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import Alert from '@material-ui/lab/Alert';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import FundingInstructionsCollapsibleCardContainer
  from 'Components/Modals/AccountFundingInstructions/FundingInstructionsCollapsibleCard/FundingInstructionsCollapsibleCardContainer';
import useMobileLayout from 'Hooks/useMobileLayout';
import { wizardClasses } from 'Views/Page/Content/Templates/WizardTemplates/wizardCommonStyles';

const useStyles = buildUseStyles('AccountRolloverTemplate', (theme) => ({
  root: {
    ...wizardClasses.root(theme),
  },
  container: {
    ...wizardClasses.container(theme),
  },
  content: {
    ...wizardClasses.content(theme),
  },
  title: {
    marginTop: theme.spacing(2),
  },
  spacing: {
    marginBottom: theme.spacing(4),
  },
  info: {
    fontSize: '0.9em',
    fontWeight: 400,
  },
  fundingInstructionsCard: {
    marginBottom: theme.spacing(3),
  },
  form: {
    padding: 0,
    width: '100%',
  },
}));

const AccountRolloverTemplate = ({
  className,
  resource,
  errors,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  const fundingInstructionsRelationship = resource.relationship(fr.relationships.fundingInstructions.name)?.link('related');

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Box className={classes.container}>
        <Box className={classes.content}>
          <Title
            className={classNames(classes.title, classes.spacing)}
            text={resource.attr('title')}
            test={'wizard-step-title'}
          />
          {fundingInstructionsRelationship && (
          <FundingInstructionsCollapsibleCardContainer
            defaultExpanded
            className={classes.fundingInstructionsCard}
            title={'Schedule Deposit'}
            subtitle={`${isMobile ? 'Tap' : 'Click'} to view instructions`}
            fundingInstructionsLink={fundingInstructionsRelationship}
          />
          )}
          <Alert
            className={classNames(classes.info, classes.spacing)}
            severity="info"
          >
            {resource.attr('info')}
          </Alert>
          <Subtitle
            className={classes.spacing}
            text={resource.attr('subtitle')}
          />
          <MetaFormInline
            className={classes.form}
            noIndividualSubmitButtons
            resource={resource}
            metaOverrideSet={BaseOverride}
            errorsOverride={errors}
            FieldListProps={{
              ErrorListProps: {
                scrollIntoView: true,
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

AccountRolloverTemplate.defaultProps = {
  className: '',
  errors: undefined,
};

AccountRolloverTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  errors: PropTypes.object,
};

export default AccountRolloverTemplate;
